
<ng-container *ngFor="let item of DataList_Behfa">

  <div class="row"  *ngIf="item.val.includes('.pdf')" >
    <div class="form-group col-md-12" style="padding-left: 20px;padding-right: 20px;">
      <a target="_blank" href="{{BaseUrl}}File/Help/{{item.val}}"
      class="btn btn-success"><i class="fa fa-file-pdf-o"></i> فایل ضمیمه PDF </a>
    </div>
  </div>

  <div class="row"  *ngIf="item.type==1 && !item.val.includes('.pdf')">
    <div class="form-group col-md-12" style="padding-left: 20px;padding-right: 20px;" innerHTML="{{item.val}}">
    </div>
  </div>

  <div class="row" *ngIf="item.type==2 && !item.val.includes('.pdf')">
    <div class="form-group col-md-12" style="text-align: center;"  >
      <img  style="text-align: center;max-width: 1700px;" src="{{BaseUrl}}File/Help/{{this.item.val}}"/>
    </div>
  </div>

  <div class="row" *ngIf="item.type==3 && !item.val.includes('.pdf')">
    <div class="form-group col-md-12" style="text-align: center;"  >
      <video controls style="width: 100%;" >
        <source src="{{BaseUrl}}File/Help/{{this.item.val}}" type="video/mp4">
      </video>

    </div>
  </div>

</ng-container>
